export function slugFromName(name: string | null | undefined): string {
  if (!name || name.trim().length === 0) {
    return '-';
  }

  return name
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/--/g, '-');
}

export function percentageChangeToDescription(percentageChange: number): string {
  const percentageChangeAbs = Math.abs(percentageChange);
  const isPositive = percentageChange > 0;
  if (percentageChangeAbs >= 1) {
    return isPositive ? 'Doubled or more' : 'Reduced by half or more';
  } else if (percentageChangeAbs >= 0.5) {
    return isPositive ? 'Major increase' : 'Major decrease';
  } else if (percentageChangeAbs >= 0.25) {
    return isPositive ? 'Significant increase' : 'Significant decrease';
  } else if (percentageChangeAbs >= 0.1) {
    return isPositive ? 'Moderate increase' : 'Moderate decrease';
  } else if (percentageChangeAbs > 0) {
    return 'Minor change';
  } else {
    return 'No change';
  }
}

export const poundsNumberFormat = new Intl.NumberFormat(undefined, {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const preciseNumberFormat = new Intl.NumberFormat(undefined, {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

export const percentageFormat = new Intl.NumberFormat(undefined, {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 7,
});

export const decimalPlacesOfPrecisionPercentageFormat = new Intl.NumberFormat(undefined, {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 7,
});

export const percentageShortFormat = new Intl.NumberFormat(undefined, {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
